// extracted by mini-css-extract-plugin
export var active = "_1g-7";
export var container = "_1g-0";
export var evenWidth = "_1g-4";
export var large = "_1g-5";
export var outlet = "_1g-8";
export var slide = "_1g-2";
export var small = "_1g-6";
export var tab = "_1g-3";
export var tabs = "_1g-1";